import http_data from "./http-data";
import http_sql from "./http-sql";
import axios from "axios";



//////////////////  FHIR PRACTITIONER  //////////////////////

const createUserReq_fhir = (data_user) => {
  return http_data("").post(`/fhir/Practitioner`, data_user);
};

const updatePractitionnerReq_fhir = (id_user, data_user) => {
  return http_data("").put(`/fhir/Practitioner/${id_user}`, data_user);
}

const acceptDisclaimerReq_fhir = (id_user) => {
  return http_data("").put(`/fhir/Practitioner/${id_user}`, {
    resourceType: "Practitioner",
    disclaimer_accepted: true
  });
};

const getUserAccountReq_fhir = () => {
  return http_data("").get(`/fhir/Practitioner`);
};

const findAllStaffUsersByStructureReq_fhir = (username) => {
  return http_data("").get(`/fhir/Practitioner?username=${username}`);
};

const deleteUserReq_fhir = (id_user) => {
  return http_data("").delete(`/fhir/Practitioner/${id_user}`);
};


////////////////// FHIR PATIENT   //////////////////////

const createPatient_fhir = (newProfileObject) => {
  return http_data("").post(`fhir/Patient`, JSON.stringify(newProfileObject));
};

const updatePatient_fhir = (data_patient, id_patient) => {
  return http_data("").put(`fhir/Patient/${id_patient}`, JSON.stringify(data_patient));
}

const patchPatientSpeciality = (id_patient, concerned_speciality) => {
  return http_data("").patch(`fhir/Patient/${id_patient}/speciality`, JSON.stringify({ concerned_speciality }));
}

const searchPractitioners = async (params) => {
  let query = "";
  if (params.rpps) query = `rpps=${encodeURIComponent(params.rpps)}`;
  else if (params.family && params.given) query = `family=${encodeURIComponent(params.family)}&given=${encodeURIComponent(params.given)}`;
  else query = `name=${encodeURIComponent(params.name)}`;
  return http_data("").get(`/practitioner/search?${query}`);
}

const createOrUpdateLocalPractitioner = (data) => {
  return http_data("").post(`/practitioner/local`, JSON.stringify(data));
}

const listExistingPractitioners = (query = "", structureId = null, limit = null) => {
  const params = new URLSearchParams();
  if (query) params.set("q", query);
  if (structureId) params.set("structureId", structureId);
  if (limit) params.set("limit", limit);
  const qs = params.toString() ? `?${params.toString()}` : "";
  return http_data("").get(`/practitioner/list${qs}`);
}

const listPractitionersByStructure = (targetStructureId, query = "") => {
  const params = new URLSearchParams();
  if (query) params.set("q", query);
  if (targetStructureId) params.set("targetStructureId", targetStructureId);
  const qs = params.toString() ? `?${params.toString()}` : "";
  return http_data("").get(`/practitioner/by-structure${qs}`);
}

const attributePractitionerToStructure = (id_user, FK_structure, send_invitation = false, language = "en-GB") => {
  return http_data("").put(`/practitioner/attribute`, JSON.stringify({ id_user, FK_structure, send_invitation, language }));
}

const sendPractitionerCredentials = (params) => {
  return http_data("").post(`/practitioner/send-credentials`, JSON.stringify(params));
}

const sendPractitionerResetLink = (params) => {
  return http_data("").post(`/practitioner/send-reset-link`, JSON.stringify(params));
}

const getLocalPractitioner = (rpps) => {
  return http_data("").get(`/practitioner/local/${encodeURIComponent(rpps)}`);
}

const patchPatientPractitionerSpeciality = (id_patient, rpps_id_practioner_speciality) => {
  return http_data("").patch(`fhir/Patient/${id_patient}/practitioner_speciality`, JSON.stringify({ rpps_id_practioner_speciality }));
}

const patchPatientOrdonnance = (id_patient, ordonnance_file, ordonnance_filename) => {
  return http_data("").patch(`fhir/Patient/${id_patient}/ordonnance`, JSON.stringify({ ordonnance_file, ordonnance_filename }));
}

const getPatientConsentementDownload = (id_patient) => {
  return http_data("").get(`fhir/Patient/${id_patient}/consentement/download`);
}

const getPatientOrdonnanceDownload = (id_patient) => {
  return http_data("").get(`fhir/Patient/${id_patient}/ordonnance/download`);
}

const patchPatientConsentement = (id_patient, consentement_file, consentement_filename) => {
  return http_data("").patch(`fhir/Patient/${id_patient}/consentement`, JSON.stringify({ consentement_file, consentement_filename }));
}

const patchPatientPsad = (id_patient, psad_delegate_alerts, psad_delegate) => {
  return http_data("").patch(`fhir/Patient/${id_patient}/psad`, JSON.stringify({ psad_delegate_alerts, psad_delegate: psad_delegate || null }));
}

const patchPatientDelegateMedical = (id_patient, delegate_medical_alert) => {
  return http_data("").patch(`fhir/Patient/${id_patient}/delegate_medical`, JSON.stringify({ delegate_medical_alert: delegate_medical_alert || null }));
}

const patchPatientDelegateNonMedical = (id_patient, delegate_non_medical_alert) => {
  return http_data("").patch(`fhir/Patient/${id_patient}/delegate_non_medical`, JSON.stringify({ delegate_non_medical_alert: delegate_non_medical_alert }));
}

const patchPatientLppCode = (id_patient, lpp_code) => {
  return http_data("").patch(`fhir/Patient/${id_patient}/lpp_code`, JSON.stringify({ lpp_code: lpp_code || null }));
}

const postPatientShareInvite = (id_patient, recipient_email, delegate_name, delegate_phone) => {
  return http_data("").post(`fhir/Patient/${id_patient}/share_invite`, JSON.stringify({ recipient_email, delegate_name, delegate_phone }));
}

const getPatientPendingInvites = (id_patient) => {
  return http_data("").get(`fhir/Patient/${id_patient}/pending_invites`);
}

const deletePatientPendingInvite = (id_patient, request_id) => {
  return http_data("").delete(`fhir/Patient/${id_patient}/pending_invites/${request_id}`);
}

const postPatientShareInviteStructures = (id_patient, structure_ids, delegate_name, delegate_phone, invite_type, sharing_type) => {
  return http_data("").post(`fhir/Patient/${id_patient}/share_invite_structure`, JSON.stringify({ structure_ids, delegate_name, delegate_phone, invite_type, sharing_type }));
}

const getPatientStructureShares = (id_patient) => {
  return http_data("").get(`fhir/Patient/${id_patient}/structure_shares`);
}

const getSentStructureInvitations = () => {
  return http_data("").get(`sent_structure_invitations?t=${Date.now()}`);
}

const patchPatientStructureShare = (id_patient, structure_id, permissions) => {
  return http_data("").patch(`fhir/Patient/${id_patient}/structure_shares/${structure_id}`, JSON.stringify(permissions || {}));
}

const deletePatientStructureShare = (id_patient, structure_id) => {
  return http_data("").delete(`fhir/Patient/${id_patient}/structure_shares/${structure_id}`);
}

const deleteMyDelegateStructureShare = (id_patient, structure_id) => {
  return http_data("").delete(`fhir/Patient/${id_patient}/structure_shares/${structure_id}/delegate`);
}

const getPatient_fhir = (ressource_type, UUID) => {
  let arg = ""
  if (UUID !== "all") {
    arg = "?" + ressource_type + "=" + UUID;
  }
  return http_data("").get(`/fhir/Patient${arg}`);
};

const axios_Delete_Profile_fhir = async (local_id_patient) => {
    return http_data("").delete(`fhir/Patient/${local_id_patient}`)
}

const updatePatientCheckPatient = (id_patient, id_user, user_name, structure_name) => {
  return http_data("").put(`fhir/Patient/${id_patient}/check`, JSON.stringify({ id_user, user_name, structure_name }));
}


//////////////////  FHIR DEVICE   //////////////////////

const createDeviceReq_fhir = (data_device) => {
  return http_data("").post(`/fhir/Device`, data_device);
};

const updateDeviceReq_fhir = (id_device, data) => {
  return http_data("").put(`/fhir/Device/${id_device}`, data);
 };

const getAllDeviceReq_fhir = (FK_structure) => {
  return http_data("").get(`/fhir/Device`);
};

const findDeviceReq_fhir = ( criteria, val) => {
  let params = "?" + criteria + "=" + val
  return http_data("").get(`/fhir/Device${params}`);
};

const deleteDeviceReq_fhir = (FK_structure, id_device) => {
  return http_data("").delete(`/fhir/Device/${id_device}`);
};


//////////////////  FHIR GROUPS   //////////////////////

const createGroupReq_fhir = (groupParameters) => {
  return http_data("").post(`/fhir/Group`, groupParameters);
};

const updateGroupReq_fhir = (groupParameters, id_group) => {
  return http_data("").put(`/fhir/Group/${id_group}`, groupParameters);
};

const getStructureGroups_fhir = () => {
  return http_data("").get(`/fhir/Group`);
};

////////////////// FHIR STRUCTURE   //////////////////////

const getStructuresByType = (type) => {
  return http_data("").get(`/fhir/Structure?type=${encodeURIComponent(type)}`);
};

const getAllStructures = () => {
  return http_data("").get(`/fhir/Structure`);
};

const createStructure = (structureData) => {
  return http_data("").post(`/fhir/Structure`, JSON.stringify(structureData));
};

const sendStructureCredentials = (id_structure, params) => {
  return http_data("").post(`/fhir/Structure/${id_structure}/send-credentials`, JSON.stringify(params));
};

const createStructurePatient = (id_structure, payload) => {
  return http_data("").post(`/fhir/Structure/${id_structure}/patient`, JSON.stringify(payload));
};

// PSAD access: which PSAD structures a (non-PSAD) structure may use.
const getStructurePsadAccess = (id_structure) => {
  return http_data("").get(`/fhir/Structure/${id_structure}/psad-access`);
};

const setStructurePsadAccess = (id_structure, psad_structure_ids) => {
  return http_data("").put(`/fhir/Structure/${id_structure}/psad-access`, JSON.stringify({ psad_structure_ids }));
};

// PSAD structures available to the caller's own structure (concerned-speciality dropdown).
const getAvailablePsadStructures = () => {
  return http_data("").get(`/fhir/Structure/available-psad`);
};

// Practitioner access: which practitioners a structure may list in the concerned-speciality
// "Platform practitioners" dropdown. Returns { assigned_practitioner_ids: [...] }.
const getStructurePractitionerAccess = (id_structure) => {
  return http_data("").get(`/fhir/Structure/${id_structure}/practitioner-access`);
};

const setStructurePractitionerAccess = (id_structure, practitioner_ids) => {
  return http_data("").put(`/fhir/Structure/${id_structure}/practitioner-access`, JSON.stringify({ practitioner_ids }));
};

////////////////// SSL ADMIN  //////////////////////

const getSslInfo = () => {
  return http_data("").get(`/admin/ssl/info`);
};

const triggerSslCheck = () => {
  return http_data("").post(`/admin/ssl/check-now`);
};

const getStructureUsers = (id_structure) => {
  return http_data("").get(`/fhir/Structure/${id_structure}/users`);
};

const getAllSubscriptions = () => {
  return http_data("").get(`/fhir/Subscription`);
};

const createSubscription = (subscriptionData) => {
  return http_data("").post(`/fhir/Subscription`, JSON.stringify(subscriptionData));
};

const updateSubscription = (id_subscription, subscriptionData) => {
  return http_data("").put(`/fhir/Subscription/${id_subscription}`, JSON.stringify(subscriptionData));
};

const assignSubscriptionToStructure = (id_structure, id_subscription) => {
  return http_data("").put(`/fhir/Structure/${id_structure}/subscription`, JSON.stringify({ id_subscription }));
};

const findGroupReq_fhir = (name) => {
  return http_data("").get(`/fhir/Group?name=${name}`);
};

const deleteGroupReq_fhir = (id_group) => {
  return http_data("").delete(`/fhir/Group/${id_group}`);
};


////////////////////////////////// FHIR OBSERVATION ///////////////////////////////////////////

const createObservation_fhir = async (data) => {
  return http_data("").post(`/fhir/Observation`, JSON.stringify(data))
}

const axios_get_observation_fhir = async (local_id_patient, startDate, endDate, type, nextResults) => {

    let request = [];

    if(nextResults !== ""){
        request = await http_data("").get(`fhir/Observation?patient=${local_id_patient}&code=${type}&${nextResults.replace('?','')}`)
    }
    else {
        request = await http_data("").get(`fhir/Observation?patient=${local_id_patient}&code=${type}&date=ge${startDate}&date=le${endDate}&count=999`)
    }
    return(request.data);
}


////////////////////////////////// FHIR LINKAGE ///////////////////////////////////////////

const updateLinkage_fhir = (data) => {
  return http_data("").put(`/fhir/Linkage`, data);
}

const getLinkage_fhir = (limits) => {
  let url = `/fhir/Linkage`
  if (limits !== null && limits !== undefined) {
    url += `?limits=${limits}`
  }
  return http_data("").get(url);
}

const getRequestsReceivedListSQL = (recipient_mail_address) => {
  return http_data("").get(`/getRequestsReceivedList/${encodeURIComponent(recipient_mail_address)}/${Date.now()}`);
};

const answerStructureRequest = (request_id, accepted) => {
  const outcome = accepted ? "accepted" : "refused";
  return http_data("").put(`/answerRequest/${Date.now()}/${request_id}/${outcome}`);
};

const answerDelegateInviteSQL = (request_id, accept) => {
  return http_data("").put(`/answerDelegateInvite/${request_id}`, { accept });
};

const deleteLinkage_fhir = (author, identifier_user, identifier_patient) => {
  let query = "?receiver_username=" + identifier_user
  if (identifier_patient !== undefined) {
    query += "&identifier_patient=" + identifier_patient
  }
  if (author !== undefined) {
    query += "&author=" + author
  }
  return http_data("").delete(`/fhir/Linkage${query}`);
}


//////////////////  PATIENT SEARCH  //////////////////////

const researchINSPatients = (data) => {
  return http_data("").get(`/researchINSPatients?birthdate=${data.birthdate}&birthname=${data.birthname}&firstname=${data.firstname}&ins_code=${data.ins_code}&id_user=${data.id_user}`);
};


//////////////////  COMPROMISED   //////////////////////

const sendCompromisedUsermailReq = (user_email) => {
  return http_sql.post("/compromisedaccount", user_email);
};


//////////////////  GATEWAY   //////////////////////

const orderGatewayAction = (FK_structure, type, id_gw) => {
  return http_data("").put(`/gatewayOrder/${FK_structure}/${type}/${id_gw}`);
};

//////////////// ADMIN FIXTURES (debug) //////////////////

const getAdminFixtures = () => {
  return http_data("").get(`/admin/fixtures`);
};

const runAdminFixture = (script, args) => {
  // Long-running scripts can take minutes; bypass per-instance timeout.
  return http_data("").post(`/admin/fixtures/run`, { script, args }, { timeout: 0 });
};

const triggerAdminAlert = (id_patient, type, value, send_sms, send_mail, recall, lang) => {
  return http_data("").post(`/admin/actions/trigger-alert`, { id_patient, type, value, send_sms, send_mail, recall, lang });
};

const sendAdminReminder = (id_patient, type, send_sms, send_mail, recall, lang) => {
  return http_data("").post(`/admin/actions/send-reminder`, { id_patient, type, send_sms, send_mail, recall, lang });
};


//////////////// CORRESPONDANT //////////////////

const Correspondant_Research = async (rpps, id_user) => {

    let research_result = await http_data("").get(`/correspondant/${rpps}/user/${id_user}`)
    return (research_result);
};

const Correspondant_Register = async (data) => {

    let register_result = await http_data("").post(`/correspondant/`, data)
    return (register_result);
};


////////////////  COMMUNICATION   //////////////////

const validateAlert = (id_alert) => {
  return http_data("").get(`/fhir/Communication/${id_alert}`);
};

const updateAlertAction = (id_alert, action) => {
  return http_data("").put(`/fhir/Communication/${id_alert}/action`, JSON.stringify({ action }));
};

const getAlertComments = (id_alert) => {
  return http_data("").get(`/fhir/Communication/${id_alert}/comments`);
};

const createAlertComment = (id_alert, FK_User, message) => {
  return http_data("").post(`/fhir/Communication/${id_alert}/comments`, JSON.stringify({ FK_User, message }));
};

const updateAlertComment = (id_alert, id_comment, FK_User, message) => {
  return http_data("").put(`/fhir/Communication/${id_alert}/comments/${id_comment}`, JSON.stringify({ FK_User, message }));
};

const deleteAlertComment = (id_alert, id_comment, FK_User) => {
  return http_data("").delete(`/fhir/Communication/${id_alert}/comments/${id_comment}?FK_User=${FK_User}`);
};


////////////////  PROVIDERS   //////////////////

const prismacloudPatientById = (id_patient) => {
  return http_data("").get(`/prismacloud_patient_by_id/${id_patient}`);
};




const DataServiceSQL = {

  // Main FHIR routes
  createUserReq_fhir,
  updatePractitionnerReq_fhir,
  acceptDisclaimerReq_fhir,
  findAllStaffUsersByStructureReq_fhir,
  getUserAccountReq_fhir,
  deleteUserReq_fhir,
  createPatient_fhir,
  updatePatient_fhir,
  patchPatientSpeciality,
  searchPractitioners,
  createOrUpdateLocalPractitioner,
  listExistingPractitioners,
  listPractitionersByStructure,
  attributePractitionerToStructure,
  sendPractitionerCredentials,
  sendPractitionerResetLink,
  getLocalPractitioner,
  patchPatientPractitionerSpeciality,
  patchPatientOrdonnance,
  getPatientConsentementDownload,
  getPatientOrdonnanceDownload,
  patchPatientConsentement,
  patchPatientPsad,
  patchPatientDelegateMedical,
  patchPatientDelegateNonMedical,
  patchPatientLppCode,
  postPatientShareInvite,
  getPatientPendingInvites,
  deletePatientPendingInvite,
  postPatientShareInviteStructures,
  getPatientStructureShares,
  getSentStructureInvitations,
  patchPatientStructureShare,
  deletePatientStructureShare,
  deleteMyDelegateStructureShare,
  getPatient_fhir,
  axios_Delete_Profile_fhir,
  updatePatientCheckPatient,

  createDeviceReq_fhir,
  updateDeviceReq_fhir,  
  findDeviceReq_fhir,
  getAllDeviceReq_fhir,
  deleteDeviceReq_fhir,
  
  getStructureGroups_fhir,
  getStructuresByType,
  getAllStructures,
  createStructure,
  sendStructureCredentials,
  createStructurePatient,
  getStructurePsadAccess,
  setStructurePsadAccess,
  getAvailablePsadStructures,
  getStructurePractitionerAccess,
  setStructurePractitionerAccess,
  getStructureUsers,
  getAllSubscriptions,
  createSubscription,
  updateSubscription,
  assignSubscriptionToStructure,
  getSslInfo,
  triggerSslCheck,
  createGroupReq_fhir,
  updateGroupReq_fhir,
  deleteGroupReq_fhir,
  findGroupReq_fhir,

  createObservation_fhir,
  axios_get_observation_fhir,

  updateLinkage_fhir,
  getLinkage_fhir,
  deleteLinkage_fhir,
  getRequestsReceivedListSQL,
  answerStructureRequest,
  answerDelegateInviteSQL,

  sendCompromisedUsermailReq,

  researchINSPatients,

  orderGatewayAction,

  getAdminFixtures,
  runAdminFixture,
  triggerAdminAlert,
  sendAdminReminder,

  Correspondant_Research,
  Correspondant_Register,

  validateAlert,

  updateAlertAction,

  getAlertComments,
  createAlertComment,
  updateAlertComment,
  deleteAlertComment,

  prismacloudPatientById
};

export default DataServiceSQL;
